import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Header from "../partials/header";
import LeftSidebar from "../partials/leftSidebar";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { CustomerFormStep1CustomerInfo } from "./customerFormStep1CustomerInfo";
import { CustomerFormStep2SiteDevice } from "./customerFormStep2SiteDevice";
import { CustomerFormStep3CreateOrder } from "./customerFormStep3CreateOrder";
import { CustomerFormStep4CustomerDetails } from "./customerFormStep4CustomerDeails";

const steps = ["Customer Info", "Create a Site / Device", "Create Order"];

const CustomerForm = () => {
  const [open, setOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [customerInfo, setCustomerInfo] = useState();
  const [customerFormValues, setCustomerFormValues] = useState();
  const [siteInfo, setSiteInfo] = useState();
  const [siteFormValues, setSiteFormValues] = useState();
  const [orderInfo, setOrderInfo] = useState();
  const [selectedFeatureValues, setSelectedFeatureValues] = useState([]);

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Header title="Register New Customer" />
        <LeftSidebar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            marginTop: 14,
            padding: "0",
          }}
        >
          <Box
            p={3}
            sx={{
              backgroundColor: "#03171F",
              color: "#ffffff",
              minHeight: "calc(100vh - 135px)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
              }}
            >
              <Stepper
                activeStep={activeStep}
                alternativeLabel
                sx={{ width: "100%" }}
              >
                {steps.map((label, index) => (
                  <Step key={index}>
                    <StepLabel className="stapeLabel">{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>

            {activeStep === 0 && (
              <Box mt={5}>
                <CustomerFormStep1CustomerInfo
                  setActiveStep={setActiveStep}
                  setCustomerInfo={setCustomerInfo}
                  customerInfo={customerInfo}
                  setCustomerFormValues={setCustomerFormValues}
                  customerFormValues={customerFormValues}
                />
              </Box>
            )}

            {activeStep === 1 && (
              <Box mt={5}>
                <CustomerFormStep2SiteDevice
                  setActiveStep={setActiveStep}
                  customerInfo={customerInfo}
                  setSiteInfo={setSiteInfo}
                  siteInfo={siteInfo}
                  setSiteFormValues={setSiteFormValues}
                  siteFormValues={siteFormValues}
                />
              </Box>
            )}

            {activeStep === 2 && (
              <Box mt={5}>
                <CustomerFormStep3CreateOrder
                  setActiveStep={setActiveStep}
                  customerInfo={customerInfo}
                  siteInfo={siteInfo}
                  setOrderInfo={setOrderInfo}
                  orderInfo={orderInfo}
                  setSelectedFeatureValues={setSelectedFeatureValues}
                  selectedFeatureValues={selectedFeatureValues}
                />
              </Box>
            )}

            {activeStep === 3 && (
              <Box mt={5}>
                <CustomerFormStep4CustomerDetails
                  setActiveStep={setActiveStep}
                  customerInfo={customerInfo}
                  siteInfo={siteInfo}
                  orderInfo={orderInfo}
                />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CustomerForm;
